import React from 'react';

import { useEntityIdentificationEntries } from '@neptune/shared/entity-business-logic';
import { Entity, mergeEntitiesByUUID } from '@neptune/shared/entity-domain';

/**
 *
 * Returns a list of attributes that are required to build entity color.
 *
 */
export function useEntityStyleAttributesQuery(
  shortIdsByProject: Map<string, string[]>,
  experimentNamesByProject: Map<string, string[]>,
) {
  const { result, isFetching } = useEntityIdentificationEntries(
    experimentNamesByProject,
    shortIdsByProject,
  );

  const data = React.useMemo(() => {
    const mergedList: Entity[] = [];

    for (const [, entries] of result.data) {
      mergedList.push(...mergeEntitiesByUUID(entries));
    }

    return mergedList;
  }, [result.data]);

  return {
    data,
    isFetching,
  };
}
